export const GET_BANNER = "GET_BANNER";
export const CREATE_NEW_BANNER = "CREATE_NEW_BANNER";
export const EDIT_BANNER = "EDIT_BANNER";
export const DELETE_BANNER = "DELETE_BANNER";


export const SHOW_ROOM_SWITCH = "SHOW_ROOM_SWITCH";
export const SHOW_HOME_SWITCH = "SHOW_HOME_SWITCH";

export const OPEN_BANNER_DIALOG = "OPEN_BANNER_DIALOG";
export const CLOSE_BANNER_DIALOG = "CLOSE_BANNER_DIALOG";
